export default __webpack_public_path__ + "src/img/main-page/nasmork-slider//nasmork_baby.png";